export interface QuestionMapping {
  match: (title: string) => boolean;
  setter: React.Dispatch<React.SetStateAction<any>>;
  multiSelect: boolean;
}

export interface PdfSection {
  title?: string;
  text?: string | string[];
  bold?: boolean;
  fillColor?: string;
  colSpan?: number;
  margin?: number[];
  rows?: { question: string; answer: string | string[] | undefined }[];
}

export interface PdfFormattedData {
  version: string;
  sections: PdfSection[];
}

export const REPORT_TYPES = {
  ASSESSMENT: 'assessment',
  SURVEY: 'survey',
} as const;

export type ReportType = typeof REPORT_TYPES[keyof typeof REPORT_TYPES];
